// master
export const baseURL = "https://pva.pixyle.ai/v4"; // master
export const demoToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE2NjUxMzIwNDksIm5iZiI6MTY2NTEzMjA0OSwianRpIjoiYTA0OTNlODgtYzkyYi00ZTZkLTlkNzctZjkwOGZhOWFkNjRjIiwiaWRlbnRpdHkiOiJhZjhhMmEzOS1hYzE2LTQ4ZTItOGU0Yi0xZjM2NDA3YjhjZmMiLCJmcmVzaCI6ZmFsc2UsInR5cGUiOiJhY2Nlc3MifQ.sdyx60njoX4lB_By-oVGDh12TjJsrYTlSPoZ-272sYo";


 export const baseLoginApiURL ="https://pva.pixyle.ai/v4/users"